<script>
  import { curSheet } from '../stores/curCheatsheet.js';
  import { cheatsheets } from '../stores/cheatsheets.js';
</script>

{#if $curSheet === 0}
<div class="reader-container" id="empty">
  <p class="hint">Click a cheatsheet to get started</p>
</div>
{:else}
<div class="reader-container">
  {#if $cheatsheets.includes($curSheet)}
  <button on:click={cheatsheets.rm($curSheet.id)} class="btn danger">del</button>
  <a href="#/cheatsheet/{$curSheet.id}/edit">
    <button class="btn">edit</button>
  </a>
  {:else}
  <h3>Deleted</h3>
  <button>Undelete</button>
  {/if}

  <div>
    <p>{$curSheet.title}</p>
    <p>{$curSheet.tags}</p>
    <p>{$curSheet.body}</p>
  </div>
</div>
{/if}

<style>
  .reader-container {
    text-align: center;
  }
  .btn {
		background-color: transparent;
		border-color: white;
		margin-top: 8px;
		display: inline-block;
	}

	.btn:hover {
		border-color: black;
	}

	.danger:hover {
		background-color: #fc8d8d;
	}
</style>
